import React from 'react';
import * as FaIcons from 'react-icons/fa';
interface InclusionIconsProps {
  inclusions: string[];
}

const FaPlaneDeparture = FaIcons.FaPlaneDeparture as unknown as React.FC<any>;
const FaHotel = FaIcons.FaHotel as unknown as React.FC<any>;
const FaShuttleVan = FaIcons.FaShuttleVan as unknown as React.FC<any>;
const FaTicketAlt = FaIcons.FaTicketAlt as unknown as React.FC<any>;
const FaPassport = FaIcons.FaPassport as unknown as React.FC<any>;
const FaShieldAlt = FaIcons.FaShieldAlt as unknown as React.FC<any>;
const FaUtensils = FaIcons.FaUtensils as unknown as React.FC<any>;

const normalizeInclusionKey = (value: string) => {
  const key = String(value || '').trim().toLowerCase();
  if (key === 'selected meals') return 'meal';
  if (key === 'selected meal' || key === 'meals') return 'meal';
  if (key === 'sightseeing & activities' || key === 'sightseeing and activities' || key === 'activity') return 'activities';
  if (key === 'transfer' || key === 'transfers') return 'transfers';
  return key;
};

const labels: Record<string, string> = {
  flight: 'Flight',
  hotel: 'Hotel',
  meal: 'Selected Meals',
  transfers: 'Transfers',
  activities: 'Sightseeing & Activities',
  visa: 'Visa',
  insurance: 'Insurance',
  'prime guidance': 'Prime Guidance',
};

const iconComponentMap: Record<string, React.FC<any> | undefined> = {
  flight: FaPlaneDeparture,
  hotel: FaHotel,
  transfers: FaShuttleVan,
  activities: FaTicketAlt,
  visa: FaPassport,
  insurance: FaShieldAlt,
  meal: FaUtensils,
  'prime guidance': FaIcons.FaUserTie as unknown as React.FC<any>,
};

const InclusionIcons: React.FC<InclusionIconsProps> = ({ inclusions }) => (
  <div className="inclusion-icons">
    {inclusions.map((rawKey, idx) => {
      const key = normalizeInclusionKey(rawKey);
      const Icon = iconComponentMap[key];
      const icon = Icon
        ? <Icon aria-hidden style={{ fontSize: 24 }} />
        : <span style={{ fontSize: '24px' }}>{key === 'meal' ? '🍽️' : key === 'insurance' ? '🛡️' : '📋'}</span>;
      const label = labels[key] || rawKey;
      return (
        <div key={`${key}-${idx}`} className="inclusion-item">
          {icon}
          <span>{label}</span>
        </div>
      );
    })}
  </div>
);

export default InclusionIcons;
